export const lpBannerOptions = [
    {
        key: 'html',
        name: 'Use HTML5'
    },
    {
        key: 'static',
        name: 'Use Static Image'
    },
];

export const notificationPageButtonOptions = [
    {
        key: 'direct-link',
        name: 'Direct link'
    },
    {
        key: 'event-id',
        name: 'Event id'
    },
    {
        key: 'sport',
        name: 'Sport'
    },
    {
        key: 'competition-id',
        name: 'Competition id'
    },
    {
        key: 'casino-game-id',
        name: 'Casino game id'
    },
];
